import { Alert, Button } from "@svea/design-system-components-react";
import { ButtonGroup, Dialog, Grid, Heading, Stack, Text, useText } from "@sveabank/cc-common";
import Hide from "../../components/hide";
import { IconWithCircle } from "../new-company/components/icon-with-circle";
import { FreeCertificateText } from "./free-certificate-text";

type Props = {
	isOpen: boolean;
	closeModal: () => void;
};

export const OrgNumberSuccessModal = ({ isOpen, closeModal }: Props) => {
	const [t, texts] = useText();

	const onContinue = () => {
		closeModal();
	};

	return (
		<Dialog
			isOpen={isOpen}
			isDismissable={false}
			center={false}
			size="auto"
			aria-label={t(texts.newCompany.payment.successModalHeading)}
		>
			<Dialog.Content>
				<Stack gap={8} align="start">
					<Heading.H1 size="h2" italic={false}>
						{t(texts.newCompany.payment.successModalHeading)}
					</Heading.H1>

					<Alert kind="success" title={t(texts.newCompany.setOrgNumber.successModalNoticeTitle)}>
						{t(texts.newCompany.setOrgNumber.successModalNoticeText)}
					</Alert>

					<Grid>
						<Grid.Col
							span={{
								base: 12,
								tablet: 8,
							}}
						>
							<Stack gap={4}>
								<Stack gap={4} direction="row" justify="start" align="start">
									<Hide to="tablet">
										<IconWithCircle icon="INFO_DETAILS" isCompleted />
									</Hide>

									<Stack>
										<Text align="start" bold className="text-text-headline">
											{t(texts.newCompany.processModalInfoHeading1)}
										</Text>
										<Text align="start">{t(texts.newCompany.processModalInfoText1)}</Text>
									</Stack>
								</Stack>
								<Stack gap={4} direction="row" justify="start" align="start">
									<Hide to="tablet">
										<IconWithCircle icon="ACCOUNTS" isCompleted />
									</Hide>

									<Stack>
										<Text align="start" bold className="text-text-headline">
											{t(texts.newCompany.processModalInfoHeading2)}
										</Text>
										<FreeCertificateText />
									</Stack>
								</Stack>
								<Stack gap={4} direction="row" justify="start" align="start">
									<Hide to="tablet">
										<IconWithCircle icon="BANK" isCompleted />
									</Hide>

									<Stack>
										<Text align="start" bold className="text-text-headline">
											{t(texts.newCompany.processModalInfoHeading3)}
										</Text>
										<Text align="start">{t(texts.newCompany.processModalInfoText3)}</Text>
									</Stack>
								</Stack>
								<Stack gap={4} direction="row" justify="start" align="start">
									<Hide to="tablet">
										<IconWithCircle icon="LIST_CHECK" isCompleted />
									</Hide>

									<Stack>
										<Text align="start" bold className="text-text-headline">
											{t(texts.newCompany.processModalInfoHeading4)}
										</Text>
										<Text align="start">{t(texts.newCompany.processModalInfoText4)}</Text>
									</Stack>
								</Stack>
							</Stack>
						</Grid.Col>
					</Grid>
				</Stack>
			</Dialog.Content>
			<Dialog.Footer>
				<ButtonGroup align="end" row>
					<Button onPress={onContinue}>{t(texts.common.ok)}</Button>
				</ButtonGroup>
			</Dialog.Footer>
		</Dialog>
	);
};
